/**
 * Shared utilities for 3D booth structure renderers.
 */

/** Darken a hex color by `amount` (0..1). */
export function darkenColor(hex, amount) {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.max(0, ((num >> 16) & 0xff) - amount * 255);
  const g = Math.max(0, ((num >> 8) & 0xff) - amount * 255);
  const b = Math.max(0, (num & 0xff) - amount * 255);
  return '#' + ((1 << 24) | (Math.floor(r) << 16) | (Math.floor(g) << 8) | Math.floor(b)).toString(16).slice(1);
}
